var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-screen-loader",attrs:{"role":"alert","aria-label":"loading"}},[_c('progress-spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }